import { useState, useMemo } from 'react';
import 'core-js/es/object/group-by';

export function useMapFilters(pickupPoints: any[]) {
  const [selectedDeliveryProviders, setSelectedDeliveryProviders] = useState<string[]>([]);

  const deliveryProviders = useMemo(() => {
    const deliveryProvidersSet = new Set();
    pickupPoints.forEach((point) => deliveryProvidersSet.add(point.deliveryProviderName));
    return Array.from(deliveryProvidersSet.values());
  }, [pickupPoints]);

  const groupedPickupPoints = useMemo(
    () => Object.groupBy(pickupPoints, (item) => item.deliveryProviderName),
    [pickupPoints]
  );

  const filteredPickupPoints = useMemo(() => {
    if (!selectedDeliveryProviders.length) return pickupPoints;
    return selectedDeliveryProviders.flatMap((provider) => groupedPickupPoints[provider]);
  }, [selectedDeliveryProviders, groupedPickupPoints, pickupPoints]);

  const toggleDeliveryProvider = (provider: string) => {
    let newArr: string[] = [];
    if (selectedDeliveryProviders.includes(provider)) {
      newArr = selectedDeliveryProviders.filter((item) => item !== provider);
    } else {
      newArr = [...selectedDeliveryProviders, provider];
    }
    setSelectedDeliveryProviders(newArr);
  };

  return {
    selectedDeliveryProviders,
    deliveryProviders,
    filteredPickupPoints,
    toggleDeliveryProvider,
    setSelectedDeliveryProviders,
  };
}
